import React from "react"

import { useAppUI } from "providers/ui"
import { useTranslation } from "providers/i18n"

import { CarouselNavigationMenu } from "../../components/CarouselNavigationMenu/index.kiosk-v"
import { MainCarouselNavigation } from "extensions/iconsiam/components/navigation"

export const AppNavigation = () => {
  const { sideMenus, matchedPath, matchedRouteOption } = useAppUI()
  const { i18n } = useTranslation()

  return (
    matchedRouteOption?.showAppLayoutNav && (
      <MainCarouselNavigation
        value={matchedPath?.to || "/maps"}
        navigations={sideMenus}
        MenuItem={CarouselNavigationMenu}
        translations={i18n?.resolvedLanguage}
      />
    )
  )
}
